import { useContext } from 'react';
import userContext from '../contexts/userContext';

function useCurrentUser() {
  return useContext(userContext);
}

export default useCurrentUser;
